module.exports = "<div id=\"loader\" [hidden]=\"status != 'loading'\">\n    <itpx-spinner></itpx-spinner>\n</div>\n\n<div class=\"scorm-cloud-content\" *ngIf=\"iframeUrl && status != 'loading'\">\n  <iframe [src]=\"iframeUrl | safeUrl\"></iframe>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/content/scormcloud/scorm-cloud.component.html
// module id = 865
// module chunks = 0